export const PREFERRED_LOCALE_STORAGE_KEY = 'preferredLocale';

export const SUPPORTED_LOCALES = ['en', 'uk'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

/** Used as i18next `fallbackLng` and when a key is missing in {@link tStatic}. */
export const I18N_FALLBACK_LOCALE: SupportedLocale = DEFAULT_LOCALE;

export function parseStoredLocale(raw: string | null): SupportedLocale | undefined {
  if (!raw) {
    return undefined;
  }
  const normalized = raw.trim().toLowerCase();
  for (const locale of SUPPORTED_LOCALES) {
    if (normalized === locale || normalized.startsWith(`${locale}-`)) {
      return locale;
    }
  }
  return undefined;
}

/**
 * Map i18next `resolvedLanguage` (e.g. `uk-UA`, `en-US`) to a supported app locale.
 */
export function normalizeI18nResolvedLanguage(resolvedLanguage: string | undefined): SupportedLocale {
  if (!resolvedLanguage) {
    return DEFAULT_LOCALE;
  }
  const languageBase = resolvedLanguage.split('-')[0]?.toLowerCase() ?? '';
  if ((SUPPORTED_LOCALES as readonly string[]).includes(languageBase)) {
    return languageBase as SupportedLocale;
  }
  return DEFAULT_LOCALE;
}
